export default "__VITE_ASSET__Dol9BfEf__"